import React from 'react'

const ScheduleinterviewIcon = () => {
  return (
    <svg
      width="80"
      height="68"
      viewBox="0 0 80 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="12" width="56" height="56" rx="28" fill="#EFF8F4" />
      <mask
        id="mask0_536_79103"
        maskUnits="userSpaceOnUse"
        x="16"
        y="28"
        width="24"
        height="24"
      >
        <rect x="16" y="28" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_536_79103)">
        <path
          d="M31.85 49.8L29.7 47.65C29.5167 47.4667 29.425 47.2333 29.425 46.95C29.425 46.6667 29.5167 46.4333 29.7 46.25C29.8833 46.0667 30.1167 45.975 30.4 45.975C30.6833 45.975 30.9167 46.0667 31.1 46.25L32.525 47.675L36.075 44.125C36.2583 43.9417 36.4917 43.85 36.775 43.85C37.0583 43.85 37.2917 43.95 37.475 44.15C37.675 44.35 37.775 44.5833 37.775 44.85C37.775 45.1167 37.675 45.35 37.475 45.55L33.25 49.8C33.0667 49.9833 32.8333 50.075 32.55 50.075C32.2667 50.075 32.0333 49.9833 31.85 49.8ZM25 43.4L24.1 44.3C23.9167 44.4833 23.6833 44.575 23.4 44.575C23.1167 44.575 22.8833 44.4833 22.7 44.3C22.5167 44.1167 22.425 43.8833 22.425 43.6C22.425 43.3167 22.5167 43.0833 22.7 42.9L23.6 42L22.7 41.1C22.5167 40.9167 22.425 40.6833 22.425 40.4C22.425 40.1167 22.5167 39.8833 22.7 39.7C22.8833 39.5167 23.1167 39.425 23.4 39.425C23.6833 39.425 23.9167 39.5167 24.1 39.7L25 40.6L25.9 39.7C26.0833 39.5167 26.3167 39.425 26.6 39.425C26.8833 39.425 27.1167 39.5167 27.3 39.7C27.4833 39.8833 27.575 40.1167 27.575 40.4C27.575 40.6833 27.4833 40.9167 27.3 41.1L26.4 42L27.3 42.9C27.4833 43.0833 27.575 43.3167 27.575 43.6C27.575 43.8833 27.4833 44.1167 27.3 44.3C27.1167 44.4833 26.8833 44.575 26.6 44.575C26.3167 44.575 26.0833 44.4833 25.9 44.3L25 43.4ZM21 50C20.45 50 19.979 49.8043 19.587 49.413C19.1957 49.021 19 48.55 19 48V34C19 33.45 19.1957 32.9793 19.587 32.588C19.979 32.196 20.45 32 21 32H22V31C22 30.7167 22.0957 30.479 22.287 30.287C22.479 30.0957 22.7167 30 23 30C23.2833 30 23.521 30.0957 23.713 30.287C23.9043 30.479 24 30.7167 24 31V32H32V31C32 30.7167 32.096 30.479 32.288 30.287C32.4793 30.0957 32.7167 30 33 30C33.2833 30 33.5207 30.0957 33.712 30.287C33.904 30.479 34 30.7167 34 31V32H35C35.55 32 36.021 32.196 36.413 32.588C36.8043 32.9793 37 33.45 37 34V40.35L35 42.375V38H21V48H27.25L29.225 50H21Z"
          fill="#5DB594"
        />
      </g>
      <mask
        id="mask1_536_79103"
        maskUnits="userSpaceOnUse"
        x="56"
        y="0"
        width="24"
        height="24"
      >
        <rect x="56" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask1_536_79103)">
        <path
          d="M75 9L73.75 6.25L71 5L73.75 3.75L75 1L76.25 3.75L79 5L76.25 6.25L75 9ZM75 23L73.75 20.25L71 19L73.75 17.75L75 15L76.25 17.75L79 19L76.25 20.25L75 23ZM65 20L62.5 14.5L57 12L62.5 9.5L65 4L67.5 9.5L73 12L67.5 14.5L65 20ZM65 15.15L66 13L68.15 12L66 11L65 8.85L64 11L61.85 12L64 13L65 15.15Z"
          fill="#BEE1D4"
        />
      </g>
    </svg>
  )
}

export default ScheduleinterviewIcon
